<template>
  <v-dialog v-model="dialog" max-width="350" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-on="on"
        v-bind="attrs"
        color="error"
        :large="!isMobile()"
        title="Remover autorizado"
        ><v-icon>mdi-delete</v-icon></v-btn
      >
    </template>
    <v-card>
      <v-card-title class="font-weight-bold">Remover autorizado</v-card-title>
      <v-card-subtitle>{{ autorizado.nome }}</v-card-subtitle>
      <v-card-text class="subtitle-1">
        Confirma a exclusão do autorizado {{ autorizado.nome }}?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="error"
          rounded
          :loading="removendoAutorizado"
          @click="remover()"
          >Sim, remover</v-btn
        >
        <v-btn
          text
          rounded
          @click="dialog = false"
          :disabled="removendoAutorizado"
          >Cancelar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    autorizado: { type: Object },
  },
  computed: {
    ...mapState("configComprasPrazo", ["removendoAutorizado"]),
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    ...mapActions("configComprasPrazo", [
      "removerAutorizado",
      "carregarAutorizados",
      "removerAutorizado",
    ]),
    async remover() {
      var ret = await this.removerAutorizado(this.autorizado.id);
      if (ret) {
        this.dialog = false;
        await this.carregarAutorizados();
      }
    },
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>